module.exports = __webpack_public_path__ + "static/mobby-dark-3005aa50d9564f8902b7b870f2eccbbc.svg";